import { useTranslations } from 'next-intl';
import ReactSelect from 'react-select';
import { customStyles } from '@/components/ui/inputFormik/select-input-formik';

function Header({ handlePeriodChange }) {
  const t = useTranslations('');

  const options = [
    { value: 'today', label: t('common.Today') },
    { value: 'last_week', label: t('common.Last Week') },
    { value: 'last_3_week', label: t('common.Last 3 Weeks') },
    { value: 'last_month', label: t('common.Last Month') },
    { value: 'last_year', label: t('common.Last Year') },
    { value: null, label: t('common.All') },
  ];

  return (
    <div className='mb-2 flex items-center justify-between lg:mb-7.5'>
      <h2 className='text-xl font-bold max-lg:text-lg max-md:text-base max-sm:text-[13px]'>
        <span>{t('user.orders_key')}</span>
      </h2>
      <ReactSelect
        name='period'
        classNamePrefix='react-select'
        styles={customStyles}
        options={options}
        defaultValue={options[2]}
        onChange={(selected) => handlePeriodChange(selected.value)}
        className='sm:w-[182px]'
      />
    </div>
  );
}

export default Header;
